import { Typography } from '~ui'

const { Paragraph } = Typography

const ConditionsOfSale: React.FC = () => (
  <div>
    <Paragraph>
      Buyer acknowledges that Granted is a technology platform that facilitates the availability of
      custom and VIP “experiences” to its customers by acting as an intermediary between you (as the
      buyer) and- suppliers, vendors, sellers, brokers or other third parties (collectively
      “Supplier”). “Experiences” (also referred to as Services”) shall mean certain goods and
      services including without limitation (a) items, goods, collectables, rarities, or any other
      products in physical or digital form (“Products”) and (b) event experiences including
      in-person events such as concerts, sporting events, meet and greets, and so forth (“Events”).
    </Paragraph>
    <Paragraph>
      The Supplier, not Granted, is responsible for honoring the purchase of any Experience. The
      supplier may require you to enter into an agreement with the Supplier and you acknowledge that
      if you fail to do so, you may not be able to participate in the Experience; in such an event,
      you may not receive a refund or exchange for the purchase of your Experience. Some Experiences
      include the ability to interact with a Supplier. We do not, and cannot control interactions
      with Suppliers; and we expressly disclaim any liability arising from such interactions. You
      may be required to sign and return a waiver and liability release before you participate in an
      Experience.
    </Paragraph>
    <Paragraph>
      You acknowledge that any contract entered into by you with any Supplier is an independent
      contract. Granted is not responsible for any act or omission of any Supplier or any loss
      incurred by you as a result of any act or omission of a Supplier whether or not arranged
      through the Granted.
    </Paragraph>
    <Paragraph>
      Moreover, Granted is not responsible for any incorrect information in brochures or websites
      supplied by ourselves but produced by a Supplier. All descriptions of any Experiences,
      Products, or Events on the Site have been approved by the relevant Supplier. Granted shall not
      be liable for any inaccurate or misleading descriptions.
    </Paragraph>
    <Paragraph>
      Additionally, The Services provide a platform for Sellers to offer Packages for Auction to
      Users, and for the User with the highest bid at the close of the Auction to purchase the
      Package. Granted is responsible for the operation of the Services only and serves only as a
      technology platform to facilitate Auctions and the Custom Experiences Program. Experiences may
      not be assigned, sold, gifted or conveyed to another party without the prior written consent
      of Granted, and any attempt to transfer an Experience shall be null and void, and will result
      in the forfeiture of the Experience and the Final Purchase Price.
    </Paragraph>
    <Paragraph>
      The ending time for each Auction is stated on the bidding page for each such Packages. Bids
      will be accepted from the opening of the Auction until the ending time only. Granted reserves
      the right, in its sole discretion and without notice, to extend, terminate or modify the
      Auction in the event of technical difficulties alter the proper functioning of the Site or the
      Auction.
    </Paragraph>
    <Paragraph>
      When an Auction goes live, Users are free to place bids under their User Account on the
      Packages until the Auction closes. As bids are placed, Granted reserves the right to authorize
      your credit card for any bid amount placed by your User Account. Each time you are outbid
      Granted will send you an email notification advising you of such. As long as Granted Users
      keep bidding, the close time of the Auction will keep being extended in this manner.
    </Paragraph>
    <Paragraph>
      By bidding on any Packages, you agree to purchase the Property and/or Experience at the amount
      you have bid together with costs associated therewith that are disclosed on the Auction page
      for such Packages. You agree that should you bid on a Packages and your bid is the winning
      bid, that you are bound to pay Granted the winning bid amount for the Packages. You further
      agree that all bids place under your User Account are deemed to be placed by the User or with
      the User&apos;s authorization and consent, and User is solely responsible for all activity
      under his or her User Account.
    </Paragraph>
    <Paragraph>
      At the close of an Auction, Granted will review all bids for the Packages and if you are the
      highest bidder (the &quot;Winning Bidder&quot;), Granted will inform you by the email
      registered to your User Account. The highest bid is referred to herein as the &quot;Final
      Price.&quot; By bidding in an Auction you acknowledge and agree that within three to five
      (3-5) business days following the close of an Auction, the Winning Bidder&apos;s credit card
      or bank account will be charged the Final Price, plus the following costs and fees
      (collectively, the “Costs”): sales tax, use tax, DST, VAT and any other applicable taxes,
      buyer&apos;s premium, plus shipping costs, and insurance costs while in transit (collectively,
      the Final Price plus the Costs are the &quot;Final Purchase Price&quot;). The Winning Bidder
      is also responsible for any applicable customs and/or duties. All transactions on Granted are
      displayed and charged in U.S. dollars (USD), unless specifically stated otherwise.
    </Paragraph>
    <Paragraph>
      Following collection in full of the Final Purchase Price, Granted shall retain an amount equal
      to all Costs plus a fee for providing the Services.
    </Paragraph>
    <Paragraph>
      Some of the Packages offered on this Site may be subject to a minimum price at which the
      Package will be sold (the &quot;Reserve Price&quot;). Granted is not obligated to sell the
      Package unless the Reserve Price is met and an Auction may be withdrawn if there is no bid
      equal to or above the Reserve Price.
    </Paragraph>
    <Paragraph>
      Some Package may be subject to a live auction (a &quot;Live Bid&quot;). If the Package will be
      part of a Live Bid after the bidding closes on the Site, the Package will continue to be
      auctioned off at an event sponsored by the Seller. Granted will close the on-line bidding on
      the last business day before the event, and bid on behalf of the top Granted bidder during the
      Live Bid auction. If you are the top bidder on a Live Bid item, you hereby irrevocably grant
      Granted permission to bid on the Package at the Live Bid on your behalf, up to the maximum bid
      you placed on the Site. If the bid placed on your behalf at the Live Bid is the winning bid
      during the Live Bid event, you understand and agree that Granted shall collect the Final
      Purchase Price directly from you immediately following the conclusion of the Live Bid auction.
    </Paragraph>
    <Paragraph>
      Owners of Property and/or an Experience being sold on the Site are prohibited from bidding on
      or offering to buy their own Property and/or an Experience, and shall not instruct, authorize
      or permit any other person to bid for or purchase such Property and/or an Experience on their
      behalf or to otherwise take any action that may manipulate the sale process in any way, unless
      you agree to purchase the Property and/or Experience at the price you bid.
    </Paragraph>
    <Paragraph>
      Granted reserves the right to add, change, modify, suspend or discontinue any portion of the
      Service, in its sole discretion, at any time. Your use of the Site and/or the Service,
      including the availability of new services through the Site, shall be subject to this T&Cs. In
      addition, Granted may impose limits on any portion of the Service or restrict your access to
      portions of or the entire Site in its sole discretion without notice or liability.
    </Paragraph>
  </div>
)

export default ConditionsOfSale
